module.exports = __webpack_public_path__ + "a05d0efe863446c52f2cc1ff4d34be59.pdf";